import { FC } from 'react';

type Props = {
	className?: string;
};

const CalendarIconDuotone: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			fill='none'>
			<path
				opacity='0.4'
				d='M17.5981 10.6052V10.1943C17.5981 8.8108 17.5981 7.7019 17.5355 6.7998H2.46106C2.39844 7.7019 2.39844 8.8108 2.39844 10.1943V10.6052C2.39844 14.0909 2.39844 15.8338 3.40011 16.9167C4.40179 17.9996 6.01396 17.9996 9.2383 17.9996H10.7583C13.9826 17.9996 15.5948 17.9996 16.5965 16.9167C17.5981 15.8338 17.5981 14.0909 17.5981 10.6052Z'
				fill='#2B2B2B'
			/>
			<path
				d='M14.799 2V3.59997M5.19922 2V3.59997'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M2.39844 10.1947C2.39844 6.70897 2.39844 4.96607 3.40011 3.88318C4.40179 2.80029 6.01396 2.80029 9.2383 2.80029H10.7583C13.9826 2.80029 15.5948 2.80029 16.5965 3.88318C17.5981 4.96607 17.5981 6.70897 17.5981 10.1947V10.6056C17.5981 14.0913 17.5981 15.8342 16.5965 16.9171C15.5948 18 13.9826 18 10.7583 18H9.2383C6.01396 18 4.40179 18 3.40011 16.9171C2.39844 15.8342 2.39844 14.0913 2.39844 10.6056V10.1947Z'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M2.79688 6.7998H17.1966'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default CalendarIconDuotone;
